import { SchoolLayout } from "./SchoolLayout";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/project/karuna/components/ui/card"; // @ts-ignore - card is not a valid module
import { SchoolProfileForm } from "@/project/karuna/components/school/SchoolProfileForm"; // @ts-ignore - SchoolProfileForm is not a valid module

const SchoolProfile = () => {
  return (
    <SchoolLayout>
      <div className="min-w-0 space-y-4 sm:space-y-6">
        <div>
          <h1 className="bg-gradient-to-r from-foreground to-foreground/70 bg-clip-text text-2xl font-bold sm:text-3xl">
            School Profile
          </h1>
          <p className="mt-1 text-sm text-muted-foreground sm:text-base">
            Manage your school information and teacher details
          </p>
        </div>

        <Card className="min-w-0 border-border/50 shadow-medium">
          <CardHeader className="px-3 sm:px-6">
            <CardTitle className="text-lg sm:text-xl">
              Profile Information
            </CardTitle>
          </CardHeader>
          <CardContent className="min-w-0 px-0 sm:px-6">
            <SchoolProfileForm />
          </CardContent>
        </Card>
      </div>
    </SchoolLayout>
  );
};

export default SchoolProfile;
